import { render, staticRenderFns } from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=template&id=60e6080b&scoped=true"
import script from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
import style0 from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=style&index=0&id=60e6080b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6080b",
  null
  
)

export default component.exports